<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItemsForReportTemplate"></ejs-toolbar>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="reportTemplateData"
                  :allowPaging="true"
                  ref="grid"
                  :pageSettings="pageSettings"
                  :height="screenHeight"
                  :allowExcelExport='true'
                  :rowSelected="rowSelectOfReportTemplateGrid"
                  :rowDeselected="rowDeselectOfReportTemplateGrid" >
          <e-columns>
            <e-column field="templateName" :headerText="$t('Pm.templateName')" width="25%" clipMode='EllipsisWithTooltip' textAlign="Center"></e-column>
            <e-column field="neTypeName" :headerText="$t('Pm.neType')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center"></e-column>
            <e-column field="paramTypeName" :headerText="$t('Pm.reportTask.parameterType')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center"></e-column>
            <e-column field="spaceName" :headerText="$t('Pm.reportTask.space')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center"></e-column>
            <e-column field="templateType" :headerText="$t('Pm.templateType')"  width="10%" textAlign="Center" clipMode='EllipsisWithTooltip' :formatter="templateTypeFormatter"></e-column>
            <e-column field="templateCreateTime" :headerText="$t('Pm.templateCreateTime')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center" :formatter="templateTimeFormatter"></e-column>
            <e-column field="templateUpdateTime" :headerText="$t('Pm.templateUpdateTime')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center" :formatter="templateTimeFormatter"></e-column>
            <e-column field="templateCreatePeople" :headerText="$t('Pm.templateCreatePeople')"  width="10%" clipMode='EllipsisWithTooltip' textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pagerForTemplate"
          :pageSize="pageSettings.pageSize"
          :pageCount="pageSettings.pageCount"
          :currentPage="pageSettings.currentPage"
          :totalRecordsCount="pageSettings.totalRecordsCount"
          @click="getReportTemplateList"
        ></ejs-pager>
      </div>
      <CustomDialog ref="addReportTemplateDialog" v-bind:element="addReportTemplateDialog.element" v-bind:styles="addReportTemplateDialog.styles" >
        <template v-slot:dialog-content>
          <AddGnbReportTemplate ref="addReportTemplate"></AddGnbReportTemplate>
        </template>
      </CustomDialog>
      <CustomDialog ref="editReportTemplateDialog" v-bind:element="editReportTemplateDialog.element" v-bind:styles="editReportTemplateDialog.styles" >
        <template v-slot:dialog-content>
          <EditGnbReportTemplate ref="editReportTemplate"></EditGnbReportTemplate>
        </template>
      </CustomDialog>
      <CustomDialog ref="showReportTaskDetailDialog" v-bind:element="showReportTaskDetailDialog.element" v-bind:styles="showReportTaskDetailDialog.styles" >
        <template v-slot:dialog-content>
          <ShowGnbReportTemplateDetail ref="showReportTemplateDetail"></ShowGnbReportTemplateDetail>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>
<script>
import CustomDialog from "../../../components/common/CustomDialog";
import BasicLayout from '../../../layouts/BasicLayout';
import DateUtil from "../../../components/pmConfig/util/DateUtil";
import AddGnbReportTemplate from "../../../components/pmConfig/gnb/PmReportTemplate/dialog/AddGnbReportTemplate";
import EditGnbReportTemplate from "../../../components/pmConfig/gnb/PmReportTemplate/dialog/EditGnbReportTemplate";
import ShowGnbReportTemplateDetail
  from "../../../components/pmConfig/gnb/PmReportTemplate/dialog/ShowGnbReportTemplateDetail";
import {EventBus} from "../../../plugins/eventBus";

export default {
  name: 'pmReportGnbTemplate',
  components: {
    CustomDialog,
    BasicLayout,
    AddGnbReportTemplate,
    EditGnbReportTemplate,
    ShowGnbReportTemplateDetail
  },
  data() {
    return {
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Pm.pmManagement')}`+'/' + `${this.$t('Pm.gnbManagement')}` + '/' + `${this.$t('Pm.reportTemplate')}` },
      toolbarItemsForReportTemplate:[
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Pm.addTemplate'), click: this.addTemplateDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Pm.delTemplate'), click: this.delTemplateDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Pm.editTemplate'), click: this.editTemplateDialog },
        { prefixIcon: 'icon hero-icon hero-icon-details', tooltipText: this.$t('Pm.showTemplate'), click: this.showTemplateDetail }
      ],
      reportTemplateData: [],
      pageSettings: {
        pageSize: 15,
        pageCount: 4,
        currentPage: 1,
        totalRecordsCount: 0
      },
      screenHeight: document.body.clientHeight - 240,
      templateTypeMap: new Map()
        .set(1, this.$t('Pm.systemTemplate'))
        .set(2, this.$t('Pm.customTemplate')),
      addReportTemplateDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addReportTemplateElement',
          buttonGroup: [
            { click: this.addTemplateDialogClose, buttonModel: { content: `${this.$t('Common.cancel')}` } },
            { click: this.addReportTemplateDone, buttonModel: { content: `${this.$t('Common.ok')}`, isPrimary: true }}
          ],
          title: this.$t('Pm.addTemplate')
        },
        styles: {
          width: '860px',
          height: 'auto',
          model: true,
          visible: false
        }
      },
      editReportTemplateDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'editReportTemplateElement',
          buttonGroup: [
            { click: this.editTemplateDialogClose, buttonModel: { content: `${this.$t('Common.cancel')}` } },
            { click: this.editReportTemplateDone, buttonModel: { content: `${this.$t('Common.ok')}`, isPrimary: true } }
          ],
          title: this.$t('Pm.editTemplate')
        },
        styles: {
          width: '860px',
          height: 'auto',
          model: true,
          visible: false
        }
      },
      showReportTaskDetailDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'showReportTaskDetailElement',
          buttonGroup: [
            { click: this.showTemplateDetailDialogClose, buttonModel: { content: `${this.$t('Common.cancel')}` } }
          ],
          title: this.$t('Pm.showTemplate')
        },
        styles: {
          width: '860px',
          height: 'auto',
          model: true,
          visible: false
        }
      },
      rowDataOfReportTemplate: ''
    };
  },
  mounted() {
    this.getReportTemplateList();
  },
  methods: {
    getReportTemplateList(){
      const This = this;
      This.pageSettings.currentPage = This.$refs.pagerForTemplate.ej2Instances.currentPage;
      this.axios.post('/lte/ems/pm/gnb/report/template/getReportTemplateList.html', {
        page: {
          pageNo: This.pageSettings.currentPage,
          pageSize: This.pageSettings.pageSize
        }
      }).then(response => {
        const result = response.data.resultVal;
        This.pageSettings.totalRecordsCount = result.totalCount;
        This.pageSettings.currentPage = result.pageNo;
        This.reportTemplateData = result.result;
      })
    },

    templateTypeFormatter(column,data){
      return this.templateTypeMap.get(data[column.field]);
    },

    templateTimeFormatter(column,data){
      let timeStamp = data[column.field];
      if(timeStamp == null || timeStamp == undefined){
        return "";
      }else {
        let date = new Date();
        date.setTime(timeStamp);
        return DateUtil.getDateString(date);
      }
    },

    addTemplateDialog(){
      this.$refs.addReportTemplate.bindValidateOfAddTemplate();
      this.$refs.addReportTemplateDialog.show();
    },

    delTemplateDialog(){
      let data = this.rowDataOfReportTemplate;

      if(data == null || data == ''){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      if(data.templateType == 1){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.sysTemplateNoDel') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/ems/pm/gnb/report/template/delGnbReportTemplate.html', {
        templateId: data.templateId
      }).then(response => {
        if(response && response.status == 200 && response.data == 1){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.delTemplate')}${this.$t('Pm.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.delTemplate')}${this.$t('Pm.fail')}`});
        }
        this.getReportTemplateList();
        this.$loading.hideLoadding();
      });
    },

    editTemplateDialog(){

      let data = this.rowDataOfReportTemplate

      if(data == null || data == ''){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      if(data.templateType == 1){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.sysTemplateNoEdit') });
        return;
      }
      this.$refs.editReportTemplate.templateId = data.templateId;
      this.$refs.editReportTemplate.templateName = data.templateName;
      this.$refs.editReportTemplate.neTypeCode = data.neTypeCode;
      this.$refs.editReportTemplate.neTypeName = data.neTypeName;
      this.$refs.editReportTemplate.paramTypeCode = data.paramTypeCode;
      this.$refs.editReportTemplate.paramTypeName = data.paramTypeName;
      this.$refs.editReportTemplate.spaceCode = data.spaceCode;
      this.$refs.editReportTemplate.spaceName = data.spaceName;
      let systemCounterKeys = Object.keys(JSON.parse(data.counterList));
      let customCounterKeys = Object.keys(JSON.parse(data.customCounterList));
      let counterKeys = systemCounterKeys.concat(customCounterKeys);
      this.$refs.editReportTemplate.getCounterList(counterKeys);
      this.$refs.editReportTemplateDialog.show();
    },

    showTemplateDetail(){
      let data = this.rowDataOfReportTemplate

      if(data == null || data == ''){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$refs.showReportTemplateDetail.templateName = data.templateName;
      this.$refs.showReportTemplateDetail.neTypeName = data.neTypeName;
      this.$refs.showReportTemplateDetail.paramTypeName = data.paramTypeName;
      this.$refs.showReportTemplateDetail.spaceName = data.spaceName;
      let counterListObj = JSON.parse(data.counterList);
      let customCounterListObj = JSON.parse(data.customCounterList);
      let templateCounterList = [];
      for(let key in counterListObj){
        templateCounterList.push(
          {
            text: `${this.$t('Pm.systemCounter')} — ${counterListObj[key]}`,
            value: key
          }
        )
      };
      for(let key in customCounterListObj){
        templateCounterList.push(
          {
            text: `${this.$t('Pm.customCounter')} — ${customCounterListObj[key]}`,
            value: key
          }
        )
      };

      this.$refs.showReportTemplateDetail.templateCounterList = templateCounterList;
      this.$refs.showReportTaskDetailDialog.show();
    },

    addTemplateDialogClose(){
      this.$refs.addReportTemplateDialog.close();
    },

    editTemplateDialogClose(){
      this.$refs.editReportTemplateDialog.close();
    },

    showTemplateDetailDialogClose(){
      this.$refs.showReportTaskDetailDialog.close();
    },

    addReportTemplateDone(){
      const ruleDatas = this.$refs.addReportTemplate.validateOfAddTemplate();
      if (!ruleDatas) {
        return;
      }
      let templateName = this.$refs.addReportTemplate.templateName;
      let neTypeCode = this.$refs.addReportTemplate.neTypeCode;
      let neTypeName = this.$refs.addReportTemplate.neTypeName;
      let paramTypeCode = this.$refs.addReportTemplate.paramTypeCode;
      let paramTypeName = this.$refs.addReportTemplate.paramTypeName;
      let spaceCode = this.$refs.addReportTemplate.spaceCode;
      let spaceName = this.$refs.addReportTemplate.spaceName;
      let systemCounterList= JSON.stringify(this.$refs.addReportTemplate.systemCounterList);
      let customCounterList= JSON.stringify(this.$refs.addReportTemplate.customCounterList);
      if((systemCounterList == null || systemCounterList == undefined || systemCounterList == '{}' || systemCounterList == {})
        && (customCounterList == null || customCounterList == undefined || customCounterList == '{}' || customCounterList == {} )){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectCounter') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));

      this.$axios.post('/lte/ems/pm/gnb/report/template/addGnbReportTemplate.html', {
        templateName: templateName,
        neTypeCode: neTypeCode,
        neTypeName: neTypeName,
        paramTypeCode: paramTypeCode,
        paramTypeName: paramTypeName,
        spaceCode: spaceCode,
        spaceName: spaceName,
        systemCounterList: systemCounterList,
        customCounterList: customCounterList
      }).then(response => {
        if(response && response.status == 200 && response.data == 1){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.addTemplate')}${this.$t('Pm.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.addTemplate')}${this.$t('Pm.fail')}`});
        }
        this.getReportTemplateList();
        this.$loading.hideLoadding();
      });

      this.$refs.addReportTemplateDialog.close();
    },

    editReportTemplateDone(){
      let templateId = this.$refs.editReportTemplate.templateId;
      let systemCounterList= JSON.stringify(this.$refs.editReportTemplate.systemCounterList);
      let customCounterList= JSON.stringify(this.$refs.editReportTemplate.customCounterList);
      if((systemCounterList == null || systemCounterList == undefined || systemCounterList == '{}' || systemCounterList == {})
        && (customCounterList == null || customCounterList == undefined || customCounterList == '{}' || customCounterList == {} )){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.pleaseSelectCounter') });
        return;
      }

      this.$loading.showLoadding(this.$t('System.loading'));

      this.$axios.post('/lte/ems/pm/gnb/report/template/editGnbReportTemplate.html', {
        templateId: templateId,
        systemCounterList: systemCounterList,
        customCounterList: customCounterList
      }).then(response => {
        if(response && response.status == 200 && response.data == 1){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.editTemplate')}${this.$t('Pm.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Pm.editTemplate')}${this.$t('Pm.fail')}`});
        }
        this.getReportTemplateList();
        this.$loading.hideLoadding();
      });
      this.$refs.editReportTemplateDialog.close();
    },

    rowSelectOfReportTemplateGrid(msg) {
      this.rowDataOfReportTemplate = msg.data;
    },
    rowDeselectOfReportTemplateGrid() {
      this.rowDataOfReportTemplate = '';
    },
  },
  watch: {
  }
};
</script>
